export const sendKycReminderAnalyticsEvent = (type: string) => {
    window.dataLayer.push({
        event: 'lk_action',
        page_type: 'lk',
        section: 'all',
        type,
    });
};
